import React, { useState } from "react";
import vector from "../config/data";
import { ContactContainer } from "../components/Container";
import { NavigationBar, TopBar } from "../components/Header";
import { Footer } from "../components/Footer";
import { MessageApi } from "../services/messsage.api";
import { LoginCheckerModal } from "../components/Modal";


export function Contact()
{

    const message = MessageApi();

    const [ inputs, setInputs ] = useState();
    const [status, setStatus] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const handleInputs = ( event ) => {
        const { name , value } =  event.target ;
        setInputs( { ...inputs, [name] : value   } );
    }

    const [ loginChecker , setloginChecker ] = useState(false);
    const closeoginCheckerModal = ( arg ) => {  setloginChecker( arg ) }  

    const handleForm = async ( event ) => {
        event.preventDefault();

         if (localStorage.getItem('token')) {
            setIsLoading(true);
            setloginChecker(false);
            try {
                const res = await message.insert(inputs);
                setIsLoading(false);
                (res.data.success) ? setStatus(1) : setStatus(-1); 
            } catch (err) { 
                setStatus(-1);
                setIsLoading(false);
            }
        } 
        else{
            setloginChecker(true);  
        }
    } 

    return (

        <div className="container-fluid bg-light">

            <title> Contact | Diwane-plus </title>
            <meta name="author" content="Diwaneplus" />
            <meta name="keywords" content="entreprise immobilier, immobilier au Sénégal, Immobilier en Afrique, vente et location de maisons, vente et location de terrains, vente et location de biens immobiliers" />
            <meta name="description" content="Besoin d’informations ou d’un accompagnement personnalisé ? Contactez notre équipe via notre formulaire, téléphone ou email. Nous sommes disponibles pour répondre à vos questions et vous aider à concrétiser votre projet immobilier rapidement et efficacement." />
            <link rel="icon" type="image/png" href="../favicon.png" />

            { loginChecker ? ( <LoginCheckerModal method={ closeoginCheckerModal } message={" Refus d'accès !!! veuillez vous authentifier dabord avant d'envoyer un message."}  />  ) : null }
            
            <div className="row"> 
              <TopBar  />
            </div> 
            <div className="row sticky-top"> 
              <NavigationBar page={5} />
            </div>
            {/* ************************************************************************ */}   
            <div className="row bg-three-clr py-5 px-4 d-flex justify-content-center"> 
               <h1 className="lead fs-2 text-center text-secondary"> Nos contacts </h1>
            </div>
            {/* ************************************************************************ */}
            <div className="row justify-content-center py-5" > 
              <div className="col-lg-9 pt-4" >
                <div className="row" > 
                { 
                    vector.contact?.map(( item , index ) => { return(
                        <ContactContainer image={ item.image } tel1={ item.tel1 } tel2={ item.tel2 } key={index} />
                    )}) 
                }
                </div>
              </div> 
            </div> 
            {/* ************************************************************************ */}
            <div className="row justify-content-center">

              <div className="col-lg-9 py-5 mb-5" >
                <form className="row px-3 py-5 border bg-white rounded-3" onSubmit={handleForm} > 
                    <div className="col-md-12 mb-5" > 
                        <div className=" d-flex flex-column border-left-main px-3 ms-1 bg-gray-light py-3" > 
                            <p className="lead fs-4 text-secondary mb-1"> Envoyez-nous un message et commençons votre projet ensemble. </p>
                            <p className="text-secondary"> Chez Diwaneplus, chaque projet compte. Que vous cherchiez à louer, acheter ou vendre, notre équipe est là pour vous écouter, vous conseiller et vous accompagner à chaque étape. </p>
                        </div> 
                    </div> 
                    {
                        isLoading ? ( <div className="col-md-12 d-flex justify-content-center mb-4"> <div className="spinner-border text-blue-clr" role="status" aria-label="Chargement"></div> </div> ) : null 
                    }
                    {
                        (status === 1) ? ( <div className="col-md-12 mb-4"> <div className="alert alert-success">  Message envoyé avec succés. Notre équipe vous contactera d'ici peu. Merci  </div> </div> ) : 
                        ( (status === -1) ?  ( <div className="col-md-12 mb-4"> <div className="alert alert-danger"> Oops ! une erreur est survenue durant l'envoie. Veuillez réessayer à nouveau  </div> </div> ) : null ) 
                    }
                    <div className="col-md-12 mb-4" > 
                        <input type="text" name="title" className="border p-3 rounded-2 text-secondary w-100" placeholder="Objet du message" required onChange={handleInputs} />
                    </div>
                    <div className="col-md-12 mb-4" > 
                        <textarea className="border p-3 rounded-2 text-secondary w-100" name="message" rows={10} placeholder="Contenu du message message" onChange={handleInputs} />
                    </div>
                    <div className="col-md-12 mb-4" > 
                        <button type="submit" className="btn btn-lg btn-main rounded-0"> Envoyez maintenant <i className="bi bi-arrow-right"></i>  </button> 
                    </div>
                </form> 
              </div>
            </div>
            {/* ************************************************************************ */}
            <div className="row"> 
                <Footer />
            </div>
        </div>
    )
}


